module.exports = __webpack_public_path__ + "img/kinito_elin.c57eba1f.jpg";